import { target, targetable } from '@github/catalyst/lib/targetable'

export default targetable(class extends HTMLElement {
  static [target.static] = [
    'initial',
    'fetching',
    'copied'
  ]

  static observedAttributes = [
    'data-api-url'
  ]

  attributeChangedCallback () {
    this.clearStates()
  }

  connectedCallback () {
    this.clearStates()

    if (this.dataset.urlHash) {
      if (location.hash === `#${this.dataset.urlHash}`) {
        this.classList.remove('hidden')
      }
    }

    this.addEventListener('click', async (e) => {
      e.stopPropagation()

      if (this.isLoading) return

      const lang = this.dataset.lang
      const apiUrl = lang ? `${this.dataset.apiUrl}?lang=${lang}` : this.dataset.apiUrl

      this.setLoading(true)

      fetch(apiUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(async response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        const text = data.text

        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text)

          if (this.dataset.urlHash) {
            history.pushState({}, '', `#${this.dataset.urlHash}`)
          }

          this.setCopied(true)

          if (this.dataset.resetChecked !== 'false') {
            setTimeout(() => { this.clearStates() }, 3000)
          }
        } else {
          alert(`Clipboard not available. Make sure you're using https://\nCopy text: ${text}`)
        }
      }).finally(() => {
        this.setLoading(false)
      })
    })
  }

  setLoading (isLoading) {
    this.isLoading = isLoading

    if (isLoading) {
      this.initial?.classList.add('hidden')
      this.initial?.classList.remove('flex')
      this.fetching?.classList.remove('hidden')
      this.fetching?.classList.add('flex')
      this.copied?.classList.add('hidden')
      this.copied?.classList.remove('flex')
    }
  }

  setCopied (isCopied) {
    if (isCopied) {
      this.initial?.classList.add('hidden')
      this.initial?.classList.remove('flex')
      this.fetching?.classList.add('hidden')
      this.fetching?.classList.remove('flex')
      this.copied?.classList.remove('hidden')
      this.copied?.classList.add('flex')
    }
  }

  clearStates () {
    this.isLoading = false

    this.initial?.classList.remove('hidden')
    this.initial?.classList.add('flex')
    this.fetching?.classList.add('hidden')
    this.fetching?.classList.remove('flex')
    this.copied?.classList.add('hidden')
    this.copied?.classList.remove('flex')
  }
})
